module.exports = __webpack_public_path__ + "static/media/become-img-1-1.0182dba2.png";